const ACHIEVEMENTS_DOMAIN = 'achievements'

const ACHIEVEMENTS_KEY = {
  ALL: 'all',
  DATA: 'data'
}

const ACHIEVEMENTS_PATH = {
  DATA: `${ACHIEVEMENTS_DOMAIN}.${ACHIEVEMENTS_KEY.DATA}`,
  ALL: `${ACHIEVEMENTS_DOMAIN}.${ACHIEVEMENTS_KEY.ALL}`,
  ALL_DATA: `${ACHIEVEMENTS_DOMAIN}.${ACHIEVEMENTS_KEY.ALL}.data`
}

const ACHIEVEMENTS_STATE = {
  [ACHIEVEMENTS_KEY.ALL]: {
    data: [],
    status: null
  },
  [ACHIEVEMENTS_KEY.DATA]: {}
}

const ACHIEVEMENTS_ACTION = {
  LOAD: 'ACHIEVEMENTS_LOAD'
}

const ACHIEVEMENTS_ANALYTICS_EVENT = {
  LOADED: 'Achievements Loaded'
}

const ACHIEVEMENTS_ENDPOINT = {
  ACHIEVEMENTS: '/achievements'
}

export {
  ACHIEVEMENTS_DOMAIN,
  ACHIEVEMENTS_KEY,
  ACHIEVEMENTS_PATH,
  ACHIEVEMENTS_STATE,
  ACHIEVEMENTS_ACTION,
  ACHIEVEMENTS_ANALYTICS_EVENT,
  ACHIEVEMENTS_ENDPOINT
}
